import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

export const Captcha = forwardRef((props,ref) => {  
    const [captchaText, setCaptchaText] = useState('');
    const [userInput, setUserInput] = useState('');
    const userInputRef = useRef(null);
    const canvasRef = useRef(null);

    const init = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        initializeCaptcha(ctx);
    };

    function getCaptcha(){
        return userInput.trim();
    }
    function getImage(){
        return captchaText.trim();
    }

    function validateCaptcha(){
        var msg = '';
        if(userInput.trim()==="") {
            msg="Enter Captcha value from image";
            userInputRef.current.focus();
        } else if(getCaptcha()!==getImage()) {
            msg="Invalid Captcha value";
            userInputRef.current.focus();
        } else {
            init();
        }
        return msg;
    }
    function clearCaptcha(value){
        setUserInput(value);
    }

    useImperativeHandle(ref, ()=>{
        return {
            validateCaptcha,clearCaptcha,getCaptcha,getImage
        }
    } )

    useEffect((runinit=init) => {
        setTimeout(function () {
            runinit();
        },100);
    },[]);  // eslint-disable-line react-hooks/exhaustive-deps

    const initializeCaptcha = (ctx) => {
        setUserInput('');
        const newCaptcha = generateCaptchaText();
        setCaptchaText(newCaptcha);
        drawCaptchaOnCanvas(ctx, newCaptcha);
    };

    const generateCaptchaText = () => {
        let captcha = '';
        for (let i = 0; i < 2; i++) {
            captcha += generateRandomChar(65, 90);
            captcha += generateRandomChar(97, 122);
            captcha += generateRandomChar(48, 57);
        }
        return captcha.split('').sort(
            () => Math.random() - 0.5).join('');
    };

    const generateRandomChar = (min, max) =>
        String.fromCharCode(Math.floor
            (Math.random() * (max - min + 1) + min));
    
    const drawCaptchaOnCanvas = (ctx, captcha) => {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        const textColors = ['rgb(0,0,0)', 'rgb(130,130,130)'];
        const letterSpace = ctx.canvas.width / captcha.length;
        for (let i = 0; i < captcha.length; i++) {
            const xInitialSpace = 2;
            ctx.font = '20px Roboto Mono';
            ctx.fillStyle = textColors[Math.floor(
                Math.random() * 2)];
            ctx.fillText(
                captcha[i],
                xInitialSpace + i * letterSpace,
                
                // Randomize Y position slightly
                Math.floor(Math.random() * 16 + 15),
                50
            );
        }
    };
    
    const handleUserInputChange = (e) => {
        setUserInput(e.target.value);
    };
    
  return (
    <>
        <div class="mb-2 mt-2">
            <label for="captcha">Captcha * :</label>
            <div class="input-group mb-3 ">
                <input type="text" maxlength="6" ref={userInputRef} class="form-control" placeholder="Enter captcha text" value={userInput} onChange={handleUserInputChange}/>
                <canvas class="ms-5 pe-1 border" ref={canvasRef} width="100"  height="35"></canvas>
                <img src="/images/reload_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Reload" alt="Reload"  class="p-1 pt-2 headericonstyle" onClick={() => initializeCaptcha(canvasRef.current.getContext('2d'))}/>
            </div>    
        </div>
    </>      
  );
    
});